import React, { useEffect, lazy } from 'react';
import { TopBar } from '../../components/layout/TopBar';
import { Header } from '../../components/layout/Header';
import { Navigation } from '../../components/layout/Navigation';
import { MobileStickyBar } from '../../components/layout/MobileStickyBar';
import { Footer } from '../../components/layout/Footer';
import { useScreenInit } from '../../useScreenInit';
import { ChevronRight, FlaskConical } from 'lucide-react';
export function ProductOptionPatterns() {
  useScreenInit();
  useEffect(() => {
    const previous = document.title;
    document.title = 'Product Option Patterns';
    return () => {
      document.title = previous;
    };
  }, []);
  return <div className="min-h-screen flex flex-col bg-brand-background" data-id="element-1689">
      <TopBar data-id="element-1690" />
      <Header data-id="element-1691" />
      <Navigation data-id="element-1692" />

      <main className="flex-grow" data-id="element-1693">
        <section className="bg-white border-b border-brand-border py-10 lg:py-12" data-id="element-1694">
          <div className="max-w-7xl mx-auto px-4" data-id="element-1695">
            {/* Breadcrumbs */}
            <nav className="flex text-sm text-gray-500 mb-6 overflow-x-auto hide-scrollbar whitespace-nowrap pb-2" data-id="element-1696">
              <ol className="flex items-center space-x-2" data-id="element-1697">
                <li data-id="element-1698">
                  <a href="/Home.html" className="hover:text-brand-maroon transition-colors" data-id="element-1699">
                    Home
                  </a>
                </li>
                <li data-id="element-1700">
                  <ChevronRight size={14} className="text-gray-400" data-id="element-1701" />
                </li>
                <li data-id="element-1702">
                  <span className="text-gray-400" data-id="element-1703">Resources</span>
                </li>
                <li data-id="element-1704">
                  <ChevronRight size={14} className="text-gray-400" data-id="element-1705" />
                </li>
                <li className="text-brand-charcoal font-medium" data-id="element-1706">
                  Product Option Patterns
                </li>
              </ol>
            </nav>

            <div className="flex items-start gap-4" data-id="element-1707">
              <div className="hidden sm:flex w-12 h-12 rounded-xl bg-brand-goldWash border border-brand-gold/30 text-brand-maroon items-center justify-center shrink-0" data-id="element-1708">
                <FlaskConical size={24} strokeWidth={1.75} data-id="element-1709" />
              </div>
              <div className="max-w-3xl" data-id="element-1710">
                <h1 className="text-3xl lg:text-4xl font-serif font-bold text-brand-charcoal mb-3" data-id="element-1711">
                  Product Option Pattern Library
                </h1>
                <p className="text-lg text-brand-muted leading-relaxed" data-id="element-1712">
                  A review prototype for exploring how product options can be
                  presented and handled across MidAtlantic product pages.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Embedded prototype */}
        <section className="py-8 lg:py-12" data-id="element-1713">
          <div className="max-w-7xl mx-auto px-4" data-id="element-1714">
            <div className="bg-white rounded-xl border border-brand-border overflow-hidden shadow-sm" data-id="element-1715">
              <iframe title="MidAtlantic product option pattern library" src="https://codex.websiteforge.net/MidAt-product-options/" loading="lazy" sandbox="allow-scripts allow-same-origin allow-popups" className="w-full block border-0 h-[calc(100vh-180px)] min-h-[640px]" data-id="element-1716" />
            </div>
          </div>
        </section>
      </main>

      <Footer data-id="element-1717" />
      <MobileStickyBar data-id="element-1718" />
    </div>;
}